import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import RentalsPage from "./Pages/RentalsPage";
import TaxiPage from "./Pages/TaxiPage";
import AboutUsPage from "./Pages/AboutUsPage";
import ServicesPage from "./Pages/ServicesPage";
import ContactsPage from "./Pages/ContactsPage";
import TransitionToTop from "./components/transitionToTop";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Router>
        <TransitionToTop />
        <Routes>
          <Route path="/" element={<Home />} />{" "}
          <Route path="/rentals" element={<RentalsPage />} />
          <Route path="/taxi" element={<TaxiPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
